import { mailConstants } from '../constants/mail.constants';

export function getMailStatusLabel(status) {
    switch(status) {
        case mailConstants.MAIL_STATUS_SENT: return 'Enviado';
        case mailConstants.MAIL_STATUS_FAILED: return 'Falha';
        default: return '';
    }
}

export function getMailStatusColor(status) {
    switch(status) {
        case mailConstants.MAIL_STATUS_SENT: return 'green';
        case mailConstants.MAIL_STATUS_FAILED: return 'red';
        default: return 'grey';
    }
}

export function getMailTypeLabel(type) {
    switch(type) {
        case mailConstants.MAIL_TYPE_REQUEST_CREATED: return 'Solicitação Criada';
        case mailConstants.MAIL_TYPE_REQUEST_APPROVED: return 'Solicitação Aprovada';
        case mailConstants.MAIL_TYPE_REQUEST_REJECTED: return 'Solicitação Rejeitada';
        case mailConstants.MAIL_TYPE_REQUEST_BY_TYPE_LABEL: return 'Solicitação por Categoria';
        case mailConstants.MAIL_TYPE_USER_WELCOME: return 'Boas Vindas';
        // Sent outside a template, which today is only the transport test e-mail
        default: return 'Teste';
    }
}
